__turbopack_context__.v({
  "section": "supportDetails-module-scss-module__yYdZza__section",
  "section-icon": "supportDetails-module-scss-module__yYdZza__section-icon",
  "section-text": "supportDetails-module-scss-module__yYdZza__section-text",
  "section-title": "supportDetails-module-scss-module__yYdZza__section-title",
});
